@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .datePickerWrapper {
    width: fit-content;
  }

  .customDatePicker {
    border: 1px solid var(--border-soft);
    padding: 20px 12px;
    width: 306px;
    background-color: var(--background-soft);

    button {
      border: none;
      font: inherit;
      color: inherit;
      background-color: transparent;
      cursor: pointer;
    }

    :global {
      .react-calendar__navigation {
        display: flex;
        margin-bottom: 16px;
        font-size: 14px;
      }

      .react-calendar__navigation__arrow {
        padding: 4px;

        &:hover {
          @include border-radius-r1;
          background-color: var(--surface-hover);
        }

        &:disabled svg {
          fill: var(--icon-disabled);
        }
      }

      .react-calendar__navigation__label {
        margin: 0 32px;
        visibility: hidden;
      }

      .react-calendar__month-view__weekdays__weekday > abbr {
        text-decoration: none;
      }

      .react-calendar__month-view__weekdays {
        margin-bottom: 4px;
        text-align: center;
        color: var(--text-disabled);
        text-transform: uppercase;
      }

      .react-calendar__month-view__days {
        @include typography-v2-body-base;
      }

      .react-calendar__month-view__days__day--neighboringMonth {
        color: var(--text-soft);
      }

      .react-calendar__month-view__days__day {
        &:hover:not(
            .react-calendar__tile--disabled,
            .react-calendar__tile--active,
            .react-calendar__tile--hoverStart,
            .react-calendar__tile--hoverEnd
          ) {
          @include border-radius-full;
          background-color: var(--surface-hover);
        }
      }

      .react-calendar__tile {
        width: 32px;
        height: 37px;
        cursor: pointer;
      }

      .react-calendar__tile--now {
        color: var(--text-primary);
      }

      .react-calendar__tile--range.react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd.react-calendar__tile--active {
        @include border-radius-full;
        background-color: var(--surface-primary);
        color: var(--text-on-primary);
      }

      .react-calendar__month-view__days__day.react-calendar__tile--range.react-calendar__tile--rangeStart {
        border-radius: 100px 0 0 100px;
        background-color: var(--surface-primary);
        color: var(--text-on-primary);
      }

      .react-calendar__month-view__days__day.react-calendar__tile--range.react-calendar__tile--rangeEnd {
        border-radius: 0 100px 100px 0;
        background-color: var(--surface-primary);
        color: var(--text-on-primary);
      }

      .react-calendar__tile--disabled {
        color: var(--text-disabled);
        cursor: unset;
      }

      .react-calendar__tile--hover {
        background-color: var(--surface-hover);
      }

      .react-calendar__tile--disabled.react-calendar__tile--hover {
        background-color: unset;
      }

      .react-calendar__tile--range {
        background-color: var(--surface-hover);
        border-radius: unset;
      }

      .react-calendar__year-view__months__month,
      .react-calendar__decade-view__years__year {
        width: 80px;
        height: 55px;
        @include typography-v2-body-base;

        &:hover:not(
            .react-calendar__tile--disabled,
            .react-calendar__tile--hasActive
          ) {
          @include border-radius-r2;
          background-color: var(--surface-hover);
        }
      }

      .react-calendar__tile--hasActive {
        @include border-radius-r2;
        background-color: var(--surface-primary);
        color: var(--text-on-primary);
      }
    }

    &.showNavLabel {
      :global(.react-calendar__navigation__label) {
        visibility: visible;

        &:hover {
          @include border-radius-r1;
          background-color: var(--surface-hover);
        }
      }
    }

    &.selectRange {
      :global(
          .react-calendar__tile--range.react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd.react-calendar__tile--active
        ) {
        &:global(.react-calendar__tile--hoverStart) {
          border-radius: 100px 0 0 100px;
        }

        &:global(.react-calendar__tile--hoverEnd) {
          border-radius: 0 100px 100px 0;
        }

        &:global(
            .react-calendar__tile--hoverStart.react-calendar__tile--hoverEnd
          ) {
          @include border-radius-full;
        }
      }

      :global(.react-calendar__tile--hover) {
        &:global(.react-calendar__tile--hoverStart) {
          border-radius: 100px 0 0 100px;
        }

        &:global(.react-calendar__tile--hoverEnd) {
          border-radius: 0 100px 100px 0;
        }
      }
    }
  }
}
